import { Box, InputCheckBox } from "@itandi/itandi-bb-ui";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { DealSearchCondition, SearchApplicationType } from "~/models/Deal";

type Props = {
	applicationType: SearchApplicationType;
	label: string;
};

export function ApplicationTypeCheckBox({ applicationType, label }: Props) {
	const { setValue, getValues, control } =
		useFormContext<DealSearchCondition>();
	const watchedApplicationTypes = useWatch({
		control,
		name: "applicationTypes"
	});
	const isChecked = watchedApplicationTypes?.includes(applicationType) ?? false;

	const onApplicationTypenChange = React.useCallback((): void => {
		const selectedApplicationTypes = getValues("applicationTypes") ?? [];
		const nextApplicationTypes = [...selectedApplicationTypes];

		if (!isChecked) {
			if (!nextApplicationTypes.includes(applicationType)) {
				nextApplicationTypes.push(applicationType);
			}
		} else {
			const index = nextApplicationTypes.indexOf(applicationType);
			if (index >= 0) {
				nextApplicationTypes.splice(index, 1);
			}

			// requestEstimation のチェックが外れたら「見積申請日」の日付条件をクリアする
			if (applicationType === "requestEstimation") {
				setValue("estimationRequestedMinDate", undefined);
				setValue("estimationRequestedMaxDate", undefined);
			}
		}

		setValue("applicationTypes", nextApplicationTypes);
	}, [isChecked, applicationType, getValues, setValue]);
	return (
		<Box margin={4} minWidth={0}>
			<InputCheckBox
				checked={isChecked}
				label={label}
				onChange={onApplicationTypenChange}
			/>
		</Box>
	);
}
